export const rootPath = '/';

export const loginPath = '/login';
export const adminSignupPath = '/admin/signup';
export const updatePasswordPath = '/update-password';

export const workspacePath = '/workspace';
export const workspaceIdPath = '/workspace/:workspaceId';

export const ordersPath = '/workspace/:workspaceId/orders';
export const customersPath = '/workspace/:workspaceId/customers';
export const routesPath = '/workspace/:workspaceId/routes';
export const driversPath = '/workspace/:workspaceId/drivers';
export const settingsPath = '/settings';
export const accountSettingsPath = '/account-settings';

// Standalone landing page for the Shopify GDPR customer-data report email deep link.
export const gdprCustomerDataReportPath = '/gdpr/customer-data-report/:requestUuid';


export const insightsPath = '/insights';
export const insightsDetailsPath = '/insights/details';

export const signupPath = '/signup';
export const verifyEmailPath = '/verify-email';
export const joinCompanyPath = '/join-company';
export const invalidInvitePath = '/invalid-invite';
export const moveCompanySuccessPath = '/move-company-success';


export const requestResetPasswordPath = '/request-reset-password';
export const checkEmailPath = '/check-email';
export const linkExpiredPath = '/link-expired';
export const linkInvalidPath = '/link-invalid';
export const resetSuccessPath = '/reset-success';
export const resetPasswordPath = '/reset-password';
